<template>
  <app-layout>
    <div v-if="currentUser">
      <div class="max-w-screen-xl mx-auto p-5">
        <div class="block border-2 rounded border-gray-100">
          <h2
            class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Affiliate
          </h2>

          <div
            v-if="loadingAffiliate"
            v-loading="loadingAffiliate"
          ></div>

          <div class="px-2 pb-2" v-if="!loadingAffiliate">
            <div class="mt-2">
              <span class="text-md mr-2">
                Code:
                <span class="font-bold">{{
                  affiliate.id
                }}</span>
              </span>
            </div>

            <div class="mt-2">
              <span class="text-md mr-2">
                Name:
                <span class="font-bold">{{
                  affiliate.name
                }}</span>
              </span>
            </div>

            <div class="mt-2">
              <span class="text-md mr-2">
                Example URL:
                <span class="font-bold"
                  >https://scaffoldhub.io?partner={{
                    affiliate.id
                  }}</span
                >
              </span>
            </div>

            <div class="mt-2">
              <span class="text-md mr-2">
                Notify Payments via Email?
                <el-switch
                  :disabled="loadingUpdateNotify"
                  :value="affiliate.notify"
                  @change="updateNotify($event)"
                ></el-switch>
              </span>
            </div>

            <div class="mt-2" v-if="affiliate.notify">
              <span class="text-md mr-2">
                Email:
                <span class="text-bold">{{
                  affiliate.email
                }}</span>
              </span>
            </div>
          </div>
        </div>

        <div
          class="mt-4 block border-2 rounded border-gray-100"
        >
          <h2
            class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Balance USD
          </h2>
          <div class="mx-2 my-3" v-loading="loadingBalance">
            <div v-if="!loadingBalance">
              <div class="mt-2">
                <span class="font-md mr-2">
                  Available For Payout:
                  <span class="font-bold">{{
                    balance.usd.availableForPayout
                      | currency
                  }}</span>
                </span>
              </div>
              <div class="mt-2">
                <span class="font-md mr-2">
                  Estimated for Future Payouts:
                  <span class="font-bold">{{
                    balance.usd.estimatedForFuturePayouts
                      | currency
                  }}</span>
                </span>
              </div>
              <div class="mt-2">
                <span class="font-md mr-2">
                  Total:
                  <span class="font-bold">{{
                    balance.usd.total | currency
                  }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="mt-4 block border-2 rounded border-gray-100"
        >
          <h2
            class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Balance BRL
          </h2>

          <div class="mx-2 my-3" v-if="!loadingBalance">
            <div class="mt-2">
              <span class="font-md mr-2">
                Available For Payout:
                <span class="font-bold">{{
                  balance.brl.availableForPayout
                    | currency('BRL')
                }}</span>
              </span>
            </div>
            <div class="mt-2">
              <span class="font-md mr-2">
                Estimated for Future Payouts:
                <span class="font-bold">{{
                  balance.brl.estimatedForFuturePayouts
                    | currency('BRL')
                }}</span>
              </span>
            </div>
            <div class="mt-2">
              <span class="font-md mr-2">
                Total:
                <span class="font-bold">{{
                  balance.brl.total | currency('BRL')
                }}</span>
              </span>
            </div>
          </div>
        </div>

        <div
          class="mt-4 block border-2 rounded border-gray-100"
        >
          <h2
            class="p-2 pl-4 border-b-2 border-gray-100 w-full bg-gray-50 block uppercase tracking-wide text-gray-700 text-xs font-bold"
          >
            Payments
          </h2>

          <div class="m-2" v-if="errorComissions">
            <span class="text-red-500 mr-2"
              >Error while loading data.</span
            >
            <el-button
              @click="listCommissions()"
              type="text"
              >Reload</el-button
            >.
          </div>

          <el-table
            :data="commissions"
            empty-text="No payments yet"
            v-if="!errorComissions"
            v-loading="loadingCommissions"
            style="width: 100%"
          >
            <el-table-column label="Date">
              <template slot-scope="scope">{{
                scope.row.createdAt | dateTime
              }}</template>
            </el-table-column>
            <el-table-column label="Provider">
              <template slot-scope="scope">
                <span>{{ scope.row.providerLabel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Id">
              <template slot-scope="scope">
                <span>{{
                  scope.row.paypalId || scope.row.stripeId
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Currency">
              <template slot-scope="scope">
                <span>{{ scope.row.currency }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Gross Amount">
              <template slot-scope="scope">
                <span>{{
                  scope.row.grossAmount
                    | currency(scope.row.currency)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Commission Amount">
              <template slot-scope="scope">
                <span>{{
                  scope.row.commissionAmount
                    | currency(scope.row.currency)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Available for Payout At"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.expectedPayoutDate | date
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="Status">
              <template slot-scope="scope">
                <el-tag
                  :type="statusColor(scope.row.status)"
                  >{{ scope.row.statusLabel }}</el-tag
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { format, parseISO } from 'date-fns';
import { mapGetters } from 'vuex';
import config from '../config';
import AffiliateService from './affiliate-service';
import * as Sentry from '@sentry/browser';

export default {
  name: 'app-affiliate',

  data() {
    return {
      loadingCommissions: true,
      commissions: [],
      errorComissions: false,

      loadingBalance: true,
      balance: {},
      errorBalance: false,

      loadingAffiliate: true,
      affiliate: {},
      errorAffiliate: false,

      loadingUpdateNotify: false,
    };
  },

  filters: {
    dateTime: function(value) {
      return value
        ? format(value, 'yyyy-MM-dd HH:mm')
        : value;
    },

    date: function(value) {
      return value
        ? format(parseISO(value), 'yyy-MM-dd')
        : value;
    },

    currency: function(value, currency = 'USD') {
      if (typeof value !== 'number') {
        return value;
      }
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },
  },

  async created() {
    const authenticated = await this.authenticatedAsync();

    if (!authenticated) {
      window.location.href = config.CLIENT_APP_URL;
      return;
    }

    return Promise.all([
      this.findBalance(),
      this.listCommissions(),
      this.findAffiliate(),
    ]);
  },

  computed: {
    ...mapGetters({
      authenticatedAsync: 'auth/authenticatedAsync',
      currentUser: 'auth/currentUser',
    }),
  },

  methods: {
    statusColor(status) {
      if (status === 'pending') {
        return undefined;
      }

      if (status === 'payout') {
        return 'success';
      }

      if (status === 'refunded') {
        return 'danger';
      }

      if (status === 'paid') {
        return 'info';
      }
    },

    async listCommissions() {
      this.loadingCommissions = true;
      this.errorComissions = false;
      try {
        this.commissions = await AffiliateService.listCommissions();
        this.loadingCommissions = false;
      } catch (error) {
        Sentry.captureException(error);
        this.loadingCommissions = false;
        this.errorComissions = true;
      }
    },

    async findBalance() {
      this.loadingBalance = true;
      this.errorBalance = false;
      try {
        this.balance = await AffiliateService.findBalance();
        this.loadingBalance = false;
      } catch (error) {
        Sentry.captureException(error);
        this.loadingBalance = false;
        this.errorBalance = true;
      }
    },

    async findAffiliate() {
      this.loadingAffiliate = true;
      this.errorAffiliate = false;
      try {
        this.affiliate = await AffiliateService.find();
        this.loadingAffiliate = false;
      } catch (error) {
        Sentry.captureException(error);
        this.loadingAffiliate = false;
        this.errorAffiliate = true;
      }
    },

    async updateNotify(value) {
      this.loadingUpdateNotify = true;
      try {
        await AffiliateService.updateNotify(value);
        await this.findAffiliate();
        this.loadingUpdateNotify = false;
      } catch (error) {
        Sentry.captureException(error);
        this.loadingUpdateNotify = false;
        await this.findAffiliate();
      }
    },
  },
};
</script>

<style></style>
